/**
 * Asserts fact is true, otherwise throw an error with invariant message
 * @param fact
 * @param msg
 * @param rest
 */
function invariant(fact, msg) {
  if (!fact) {
    const error = new Error(`INVARIANT ${msg}`);
    error.stack = error.stack?.split("\n")?.filter(d => !/at invariant/.test(d))?.join("\n");
    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }
    console.error("\n\n---\n\n", error, "\n\n", ...rest, "\n\n---\n\n");
    throw error;
  }
}

export { invariant };
//# sourceMappingURL=util-invariant.module.js.map
